import { useEffect, useState } from "react";

import { ROUTES } from "..";

const useTabFilters = (pathname: string) => {
  const initialTabIndex = (() => {
    switch (pathname) {
      case ROUTES.VehicleFiles:
      case ROUTES.Users:
      case ROUTES.Integrations:
        return 0;

      case ROUTES.DriverFiles:
      case ROUTES.UsersInvitations:
      case ROUTES.IntegrationsApi:
        return 1;

      case ROUTES.AnalysisProviders:
        return 2;

      default:
        return 0;
    }
  })();

  const [tabIndex, setTabIndex] = useState(initialTabIndex);

  useEffect(() => {
    setTabIndex(initialTabIndex);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return { tabIndex };
};

export default useTabFilters;
